// redux/actions/designationActions.js
import axios from "axios";
import { toast } from "react-hot-toast";

// API Base
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Action Types
export const FETCH_DESIGNATIONS_REQUEST = "FETCH_DESIGNATIONS_REQUEST";
export const FETCH_DESIGNATIONS_SUCCESS = "FETCH_DESIGNATIONS_SUCCESS";
export const FETCH_DESIGNATIONS_FAILURE = "FETCH_DESIGNATIONS_FAILURE";

export const CREATE_DESIGNATION_REQUEST = "CREATE_DESIGNATION_REQUEST";
export const CREATE_DESIGNATION_SUCCESS = "CREATE_DESIGNATION_SUCCESS";
export const CREATE_DESIGNATION_FAILURE = "CREATE_DESIGNATION_FAILURE";

export const UPDATE_DESIGNATION_REQUEST = "UPDATE_DESIGNATION_REQUEST";
export const UPDATE_DESIGNATION_SUCCESS = "UPDATE_DESIGNATION_SUCCESS";
export const UPDATE_DESIGNATION_FAILURE = "UPDATE_DESIGNATION_FAILURE";

export const DELETE_DESIGNATION_REQUEST = "DELETE_DESIGNATION_REQUEST";
export const DELETE_DESIGNATION_SUCCESS = "DELETE_DESIGNATION_SUCCESS";
export const DELETE_DESIGNATION_FAILURE = "DELETE_DESIGNATION_FAILURE";

// Fetch all designations
export const fetchDesignations = () => async (dispatch) => {
  dispatch({ type: FETCH_DESIGNATIONS_REQUEST });
  const token = localStorage.getItem("token");

  try {
    const res = await axios.get(`${BASE_URL}/v1/api/admin/getDesignations`, {
      headers: { Authorization: token },
    });

    dispatch({ type: FETCH_DESIGNATIONS_SUCCESS, payload: Array.isArray(res.data.data) ? res.data.data : [] });
  } catch (error) {
    dispatch({
      type: FETCH_DESIGNATIONS_FAILURE,
      payload: error.response?.data?.meta?.message || error.message,
    });
  }
};

// Create designation
export const createDesignation = (data) => async (dispatch) => {
  dispatch({ type: CREATE_DESIGNATION_REQUEST });
  const token = localStorage.getItem("token");

  try {
    const res = await axios.post(`${BASE_URL}/v1/api/admin/createDesignation`, data, {
      headers: { Authorization: token, "Content-Type": "application/json" },
    });

    dispatch({ type: CREATE_DESIGNATION_SUCCESS, payload: res.data.data });
    toast.success(res.data?.meta?.message || "Designation created successfully");
    dispatch(fetchDesignations());
  } catch (error) {
    const msg = error.response?.data?.meta?.message || error.message;
    dispatch({ type: CREATE_DESIGNATION_FAILURE, payload: msg });
    toast.error(msg);
  }
};

// Update designation
export const updateDesignation = (id, data) => async (dispatch) => {
  dispatch({ type: UPDATE_DESIGNATION_REQUEST });
  const token = localStorage.getItem("token");

  try {
    const res = await axios.put(`${BASE_URL}/v1/api/admin/updateDesignation/${id}`, data, {
      headers: { Authorization: token, "Content-Type": "application/json" },
    });

    dispatch({ type: UPDATE_DESIGNATION_SUCCESS, payload: res.data.data });
    toast.success(res.data?.meta?.message || "Designation updated successfully");
    dispatch(fetchDesignations());
  } catch (error) {
    const msg = error.response?.data?.meta?.message || error.message;
    dispatch({ type: UPDATE_DESIGNATION_FAILURE, payload: msg });
    toast.error(msg);
  }
};

// Delete designation
export const deleteDesignation = (id) => async (dispatch) => {
  dispatch({ type: DELETE_DESIGNATION_REQUEST });
  const token = localStorage.getItem("token");

  try {
    const res = await axios.delete(`${BASE_URL}/v1/api/admin/deleteDesignation/${id}`, {
      headers: { Authorization: token },
    });

    dispatch({ type: DELETE_DESIGNATION_SUCCESS, payload: id });
    toast.success(res.data?.meta?.message || "Designation deleted successfully");
    dispatch(fetchDesignations());
  } catch (error) {
    const msg = error.response?.data?.meta?.message || error.message;
    dispatch({ type: DELETE_DESIGNATION_FAILURE, payload: msg });
    toast.error(msg);
  }
};
